export default "__VITE_ASSET__89346ebc__"